import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { RootLayout } from "./routes/__root";
import { LoginRoute } from "./routes/login";
import { DashboardRoute } from "./routes/dashboard";
import { AdminUsersRoute } from "./routes/admin.users";
import { AdminKeysRoute } from "./routes/admin.keys";
import { AdminUsageRoute } from "./routes/admin.usage";
import { AdminRevenueRoute } from "./routes/admin.revenue";
import { fetchMe } from "./lib/api";

const rootRoute = createRootRoute({
  component: () => (
    <RootLayout>
      <Outlet />
    </RootLayout>
  ),
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: async () => {
    try {
      const me = await fetchMe();
      if (me.is_admin) throw redirect({ to: "/admin/users" });
      throw redirect({ to: "/dashboard" });
    } catch (err) {
      if ((err as { to?: string })?.to) throw err;
      throw redirect({ to: "/login" });
    }
  },
  component: () => null,
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginRoute,
});

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/dashboard",
  component: DashboardRoute,
});

const adminUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin/users",
  component: AdminUsersRoute,
});

const adminKeysRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin/keys",
  component: AdminKeysRoute,
});

const adminUsageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin/usage",
  component: AdminUsageRoute,
});

const adminRevenueRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/admin/revenue",
  component: AdminRevenueRoute,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  dashboardRoute,
  adminUsersRoute,
  adminKeysRoute,
  adminUsageRoute,
  adminRevenueRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
